var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('CoverPage'),_c('div',{staticClass:"container md:px-12 px-6"},[_c('AboutComp'),_c('InternshipPosi'),_c('OpenPosi')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555 mt-12"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }